import { useEffect } from "react";
import Seo from "@/seo/Seo";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import Footer from "@/components/site/Footer";
import { BUSINESS } from "@/data/siteData";

export default function LegalLayout({ title, updated, children }) {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); document.body.style.background = "#ffffff"; }, []);
  return (
    <div className="bg-white min-h-screen">
      <Seo title={`${title} | The VIN Verifier CA`} description={`${title} for The VIN Verifier CA mobile VIN verification services.`} path={pathname} />
      <header className="border-b border-gray-100 bg-white">
        <div className="max-w-3xl mx-auto px-5 lg:px-8 h-[68px] flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="h-9 w-9 rounded-lg bg-brand flex items-center justify-center"><ShieldCheck size={18} className="text-white" /></span>
            <span className="font-display font-bold text-ink text-lg">The VIN Verifier</span>
          </Link>
          <Link to="/" className="flex items-center gap-2 text-slate2 text-sm hover:text-brand transition-colors"><ArrowLeft size={16} /> Back to site</Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-5 lg:px-8 py-14 lg:py-20">
        <h1 className="font-display font-bold text-ink tracking-tight text-3xl sm:text-4xl">{title}</h1>
        <p className="text-slate2 text-sm mt-2">Last updated {updated}</p>
        <div className="mt-8 space-y-6 text-slate2 leading-relaxed text-[15px] [&_h2]:font-display [&_h2]:font-semibold [&_h2]:text-ink [&_h2]:text-xl [&_h2]:mt-8 [&_h2]:mb-2">
          {children}
        </div>
        <p className="mt-10 text-sm text-slate2">Questions? Contact us at <a href={`mailto:${BUSINESS.email}`} className="text-brand font-medium">{BUSINESS.email}</a> or {BUSINESS.phone}.</p>
      </main>
      <Footer />
    </div>
  );
}
